import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StreamStatus, StreamingState } from "./types";

export type StreamingStateProps = StreamingState;

export const initialStreamingState: StreamingStateProps = {
  streamStatus: {},
  streamContent: {},
  isLoading: {},
};

const streamingSlice = createSlice({
  name: "streamingState",
  initialState: initialStreamingState,
  reducers: {
    setStreamStatus: (
      state,
      action: PayloadAction<{ id: string; status: StreamStatus | undefined }>
    ) => {
      const { id, status } = action.payload;
      if (status === undefined) {
        delete state.streamStatus[id];
        delete state.isLoading[id];
      } else {
        state.streamStatus[id] = status;
        // isLoading is true only during initial Loading status (before streaming starts)
        state.isLoading[id] = status === StreamStatus.Loading;
      }
    },
    setStreamContent: (state, action: PayloadAction<{ id: string; content: string }>) => {
      const { id, content } = action.payload;
      state.streamContent[id] = content;
    },
    appendStreamContent: (state, action: PayloadAction<{ id: string; content: string }>) => {
      const { id, content } = action.payload;
      state.streamContent[id] = (state.streamContent[id] || "") + content;
    },
    clearStreamData: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      delete state.streamStatus[id];
      delete state.streamContent[id];
      delete state.isLoading[id];
    },
    setStreamData: (
      state,
      action: PayloadAction<{
        id: string;
        status?: StreamStatus;
        content?: string;
      }>
    ) => {
      const { id, status, content } = action.payload;
      if (status !== undefined) {
        state.streamStatus[id] = status;
        // isLoading is true only during initial Loading status (before streaming starts)
        state.isLoading[id] = status === StreamStatus.Loading;
      }
      if (content !== undefined) {
        state.streamContent[id] = content;
      }
    },
  },
});

export const {
  setStreamStatus,
  setStreamContent,
  appendStreamContent,
  clearStreamData,
  setStreamData,
} = streamingSlice.actions;

export default streamingSlice;
